import React, { Component } from "react";
import Strings from "@my-dld/assets/strings";
import Popup from "@my-dld/components/Popup/Popup";
import { JQModal } from "@my-dld/components/Popup/Utils";
import { Entities, ProfileApi } from "@10x/dubai-rest-api";
import { StringUtil } from "@eres/core";
import { UpdateRequest, UpdateVerifyRequest } from "@10x/dubai-rest-api/dist/profile/entity";
import { AppConstants } from "../../../configApp";
import { trackEventWithData } from "@my-dld/utils/Analytics";
import Lottie from "lottie-react-web";
import { Anim } from "./VerifyEmail";
import { replaceNavigate } from "@my-dld/utils/StoreUtils";

interface Props {
	requestId: number;
	resp?: UpdateRequest;
	mobile?: string;
	email?: string;
	onDismiss?: () => void;
	onUserVerified?: () => void;
}

type ViewMode = "mobile" | "email" | "both";

interface State {
	show: ViewMode;
	hasInput: boolean;
	mobile?: string;
	email?: string;
	error?: string;
	isLoading?: boolean;
}

class VerifyPopup extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
		const setOTP = window.setOTP;
		let show: ViewMode = "both";
		if ( props.mobile && props.email ) {
			show = "both";
		} else if ( props.mobile ) {
			show = "mobile";
		} else if ( props.email ) {
			show = "email";
		}
		const hasInput = ( show === "both" || show === "mobile" );
		if ( setOTP && props.resp ) {
			this.state = {
				show: show,
				hasInput,
				email: props.resp.EmailOTP,
				mobile: props.resp.MobileOTP,
			};
		} else {
			this.state = {
				show: show,
				hasInput,
				email: "",
				mobile: ""
			};
		}
	}

	render() {
		let { email, error, isLoading, show, hasInput } = this.state;
		const buttonTitle = hasInput ? Strings.verify : Strings.back;
		return (
			<Popup
				id={ "token-verify" } showCloseButton={ true } title={ Strings.verification } onDismiss={ this.props.onDismiss }
				showIcon={ false } modalBodyContainer="">
				<div className="modal-body">
					{ ( show === "both" || show === "email" ) &&
						<React.Fragment>
							<div className="d-flex flex-column align-items-center">
								<div className="lottie-70">
									<Lottie
										key={ "emialanim" }
										options={ {
											animationData: Anim,
											loop: false,
										} }
									/>
								</div>
								<div className={ "alert mt-4 alert-info" }>
									{ Strings.verification_email_sent.format( [ this.props.email! ] ) }
								</div>
							</div>
						</React.Fragment>
					}
					{
						( show === "both" ) &&
						<hr/>
					}
					{ hasInput && <>

						<div className="text-center">
							<img
								className="mt-3 mb-3 w-90"
								src={ `${ AppConstants.rootUrl }assets/img/password.png` }/>
						</div>
					</> }
					{ ( show === "both" || show === "mobile" ) &&
						<React.Fragment>
							<p className="mt-2 text-center">{ Strings.please_enter_the_otp_on } <span>{ this.props.mobile }</span></p>
							<div className="form-group field-style text-center">
								<input
									className="form-control text-center otp-field" placeholder="******"
									value={ this.state.mobile }
									onChange={ ( e ) => {
										this.setState( {
											mobile: e.target.value
										} );
									} }
									type="number"/>
							</div>
						</React.Fragment>
					}

					{ error && <div className={ "invalid-feedback invalid-feedback-x alert alert-danger mb-0" }>
						{ error }
					</div> }

				</div>
				<div className="modal-footer d-flex justify-content-center p-2">
					<button
						className="btn btn_1 "
						type="button" onClick={ this.onVerify }>
						{ ( isLoading ) ? <div className="relative spinner-border " role="status">
							<span className="sr-only">Loading...</span>
						</div> : buttonTitle }
					</button>
				</div>
			</Popup>
		);
	}

	onVerify = () => {
		const { hasInput } = this.state;
		if ( !hasInput ) {
			JQModal( "token-verify" ).hide();
			replaceNavigate( "view" );
			return;
		}
		if ( this.state.isLoading ) return;
		this.setState( { error: undefined } );
		const rq: UpdateVerifyRequest = {};
		if ( this.props.mobile ) {
			if ( StringUtil.isEmptyStringOrNull( this.state.mobile ) || this.state.mobile!.length < 3 ) {
				this.setState( { error: Strings.invalid_otp } );
				return;
			}
			rq.MobileOTP = this.state.mobile;
		}
		this.setState( { isLoading: true } );
		trackEventWithData( "Profile", "UpdateVerify", { reqId: this.props.requestId, ...this.props.resp } );
		ProfileApi.completeProfileUpdate( this.props.requestId, rq )
		.then( Entities.validateResponseX )
		.then( r => {
			this.setState( { isLoading: false } );
			trackEventWithData( "Profile", "Updated", { reqId: this.props.requestId, ...this.props.resp } );
			if ( this.props.onUserVerified ) this.props.onUserVerified();
			JQModal( "token-verify" ).hide();
		} )
		.catch( e => {
			this.setState( { isLoading: false } );
			this.setState( { error: e.toString() } );
			trackEventWithData( "Profile", "UpdateVerifyFailed", {
				reason: e.toString(),
				reqId: this.props.requestId, ...this.props.resp
			} );
		} );
	};

	componentDidMount(): void {
		JQModal( "token-verify" ).show();
	}
}

export default VerifyPopup;
